import { store } from "common/store";

export const log = function(...args) {
    if (store.getState().settings.viewInspector) {
        console.log(...args);
    }
};
